/** @internal – central ownership rules for companion/system message producers. */
import type { CoAgentMessageSource, CoAgentType } from "./types";

type OwnershipMap = Record<string, CoAgentMessageSource>;

/**
 * E-commerce companion message ownership.
 * Key format should be stable (`ecom:<step>:<event>`).
 */
const ECOMMERCE_OWNERSHIP: OwnershipMap = {
  "ecom:step1:discovery_wait_gate": "sse",
  "ecom:step1:missing_data_prompt": "sse",
  "ecom:step2:estimates_briefing": "companion",
  "ecom:step2:plan_briefing": "companion", // legacy key — kept for old sessions
  "ecom:step3:content_inspiration_briefing": "companion",
  "ecom:step3:plan_briefing": "companion", // legacy key — kept for old sessions
  "ecom:step3:ads_briefing": "companion", // legacy key — kept for old sessions
  "ecom:step4:ads_briefing": "companion",
};

export function expectedMessageSourceForKey(
  coAgentType: CoAgentType,
  dedupeKey: string | undefined,
): CoAgentMessageSource | null {
  if (!dedupeKey) return null;
  if (coAgentType === "products") {
    return ECOMMERCE_OWNERSHIP[dedupeKey] ?? null;
  }
  return null;
}
